// @ts-nocheck
import Tooltip from "@insite/mobius/Tooltip";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC } from "react";

const StyleguideTooltips: FC = () => {
    return (
        <StyleguideSection title="Tooltips">
            <Tooltip text="Lorem Ipsum Dolor Sit Amet !" />
        </StyleguideSection>
    );
};

export default StyleguideTooltips;
